<!-- TEMPLATE -->
<template>
  <div id="addressContainer">
    <div v-if="options">
      <b-card>
        <b-form-group label-cols="6">
          <div
              v-if="$store.getters.getUser.privileges.includes('update-quote')"
              id="addAddressIcon"
              @click="addAddress">
            <dean-icon class="plusIcon"
                       :glyph="plusIcon"
                       width="18"
                       height="18"
            ></dean-icon>
          </div>
        </b-form-group>

        <b-form-group label-cols="6" label="Label" label-for="input-label1">
          <b-form-select
              id="input-label1"
              v-model="selectedAddress"
              :options="options"
              :disabled="!$store.getters.getUser.privileges.includes('change-status-quote')"
          ></b-form-select>
        </b-form-group>

        <b-form-group label-cols="6" label="Postcode" label-for="input-label2">
          <b-form-input id="input-label2" v-model="selectedAddress.postalCode" disabled></b-form-input>
        </b-form-group>

        <b-form-group label-cols="6" label="Huisnummer + toevoeging" label-for="input-label3">
          <b-form-input id="input-label3" :placeholder="houseNumberAndExtension" disabled></b-form-input>
        </b-form-group>

      </b-card>
    </div>
  </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import {
    BCard,
    BFormGroup,
    BFormInput,
    BFormSelect,
  } from 'bootstrap-vue';
  import {
    plusIcon,
  } from '@deanone/dean-components';
  import axios from 'axios';
  import {deanDialogBus} from '@/main';


  @Component({
    components: {
      BCard,
      BFormGroup,
      BFormInput,
      BFormSelect,
      plusIcon,
    },
  })
  export default class DisplayAddress extends Vue {
    @Prop() public customer!: string;
    public options: [] = [];
    public selectedAddress: any = {
      postalCode: '',
      houseNumber: '',
    };
    public plusIcon: object = plusIcon;
    public houseNumberAndExtension: string = '';
    private readonly addressesUrl: string = '/-/trade/api/customer.addresses.list';

    get combinedHouseNumberAndExtension() {
      let extension = '';

      if (this.selectedAddress.houseNumberExtension !== null) {
        extension = extension + '-' + this.selectedAddress.houseNumberExtension;

        if (this.selectedAddress.roomNumber !== null) {
          extension = extension + '-' + this.selectedAddress.roomNumber;
        }
      } else if (this.selectedAddress.roomNumber !== null) {
        extension = extension + '-' + this.selectedAddress.roomNumber;
      }

      return this.selectedAddress.houseNumber + extension;
    }

    @Watch('selectedAddress')
    public update() {
      this.$emit('address', this.selectedAddress);
      this.houseNumberAndExtension = this.combinedHouseNumberAndExtension;
    }

    public getAddresses(newAddress?: string) {
      if (this.$store.getters.getUser.privileges.includes('change-status-quote')) {
        axios.post(this.addressesUrl, {
          id: this.customer,
        }).then(
            (response: any) => {
              const result: any[number] = [];
              response.data.forEach((element: any) => {
                result.push({
                  text: element.label,
                  value: element,
                });
              });
              Vue.set(this, 'options', result);

              if (! newAddress && result.length) {
                this.selectedAddress = result[0].value;
              }

              if (newAddress && result.length) {
                const addressList = result;
                const newAddressKey: any = Object.keys(addressList).find(
                    (key) => addressList[key].value.id === newAddress,
                );

                this.selectedAddress = addressList[newAddressKey].value;
              }

              (this as any).loading = false;
            },
            (error) => {
              // tslint:disable-next-line:no-console
              console.error(error);
            },
        );
      }
    }

    public created() {
      this.getAddresses();
    }

    public mounted() {
      deanDialogBus.$on('RefreshAddresses', (payload: any) => {
        this.getAddresses(payload.addressId);
      });
    }

    public addAddress() {
      deanDialogBus.$emit('open', 'AddAddressDialog', {
        personId: this.customer,
      });
    }
  }

</script>


<!-- STYLE -->

<style lang='scss' scoped>

  .plusIcon {
    float: right
  }

  #addAddressIcon {
    float: right;
    width: 30px;
    height: 30px;
  }
</style>
